module.exports = __webpack_public_path__ + "static/media/018.113936ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/018.jpg
// module id = 562
// module chunks = 0